export const API_KEY = 'MqCFZ69YCBdB4NuibHlIY7fNVp6K86Kx&q'

export const API_URL = 'https://api.giphy.com/v1'
export const _API_URL = 'https://api.giphy.com/v1/gifs/search?api_key=MqCFZ69YCBdB4NuibHlIY7fNVp6K86Kx=&limit=1'
